module.exports = __webpack_public_path__ + "img/bg.0828733e.png";